import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';

export const StyledScimSetting = styled.div`
  display: flex;
  align-items: flex-start;
  & > main {
    padding-top: 1rem;
    & > header {
      font-weight: 400;
      font-size: 1.3rem;
    }
    & > section {
      font-size: 1.1rem;
      margin-top: 1rem;
      color: ${getColor('shuttleGray')};
    }
  }
`;
